export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10718.2cc57a99.jpg";